<template>
  <div id="payment-and-refill" style="padding: 40px 0 0px 0 ">
    <div class="upper-content">
      <lines-card :fetchedBefore="true"  :data="lineCard" />
      <additional-info-card type="animated" :fetchedBefore="true" :data="data.additionalInfo" />
    </div>
  </div>
</template>
<script>
import LinesCard from '../../components/cards/LinesCard'
import AdditionalInfoCard from '../../components/cards/AdditionalInfoCard'
import ProductCategoryRepository from '../../repositories/ProductCategoryRepository'
export default {
  components: { LinesCard, AdditionalInfoCard },
  name: 'PaymentAndRefillContent',
  props: {
    additionalInfo: Array,
    lineCard: String
  },
  data () {
    return {
      productRepo: new ProductCategoryRepository(),
      data: {
        html: '',
        additionalInfo: []
      }
    }
  },
  created () {
    for (let i = 0; i < this.additionalInfo.length; i++) {
      this.data.additionalInfo.push(this.additionalInfo[i].text)
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.upper-content{
  background-image: url("../../assets/images/line-page-circles.svg");
  background-position: right;
}
</style>
